import { compose, includes } from 'ramda';
import { useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';

import { codelistProvider, ComponentLoader } from 'components';
import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import { codelists } from 'constants/codelists';
import { USER_ROLES } from 'constants/general';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import fetch from 'features/common/fetch';
import { subheaders } from 'features/common/Subheader/constants';
import formDescriptorFnProductionFilter, {
	PRODUCED_PRODUCTION_FILTER_FORM_NAME,
} from 'features/views/production/documents/form';
import { getCurrentRole } from 'features/views/user/selectors';

import DocumentsTable from './components/DocumentsTable';
import Filter from './components/Filter';
import Toolbar from './components/Toolbar';
import ProducedProductionNewModal from './modals/producedProductionNew/ProducedProductionNewModal';
import ProducedProductionReportModal from './modals/producedProductionReport/ProducedProductionReportModal';

export const ProducedProduction = () => {
	const currentRole = useSelector(getCurrentRole);
	const initiallyOpen = !includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.user}>
			<Panel screenId={PAGES.producedProduction.id} screenName={PAGES.producedProduction.name}>
				<Form name={PRODUCED_PRODUCTION_FILTER_FORM_NAME} formDescriptorFn={formDescriptorFnProductionFilter}>
					<PaperWithToolbar
						toggledElement={<Filter />}
						toolbar={<Toolbar />}
						collapsibleProps={{ id: subheaders.producedProduction, initiallyOpen }}
					>
						<DocumentsTable role={currentRole} />
					</PaperWithToolbar>
					<ProducedProductionReportModal id={MODALS.producedProduction_report} />
					<ProducedProductionNewModal id={MODALS.producedProduction_new} />
				</Form>
			</Panel>
		</ComponentLoader>
	);
};

export default compose(
	codelistProvider(codelists.solutionState, 'solutionStates'),
	codelistProvider(codelists.ppDocumentType, 'ppDocumentTypeCodelist'),
)(ProducedProduction);
